(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fr-welcome-signup"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const dialog = document.getElementById('FrWelcomeSignup');
    if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
    dialog.dataset.ready = 'true';
    const key = '40r-welcome-v2';
    const week = 7 * 24 * 60 * 60 * 1000;
    const read = () => { try { return JSON.parse(localStorage.getItem(key) || sessionStorage.getItem(key) || '{}'); } catch (_) { return {}; } };
    const save = state => { try { localStorage.setItem(key, JSON.stringify(state)); } catch (_) { try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {} } };
    let previousFocus;
    const open = () => {
      previousFocus = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('fr-welcome-open');
      dialog.querySelector('[data-welcome-close]').focus({preventScroll:true});
    };
    dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('fr-welcome-open');
      const state = read();
      if (!state.subscribed) save({until:Date.now()+week});
      if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
    });
    const result = dialog.querySelector('[data-welcome-result]');
    const ownReturn = location.hash === '#FrWelcomeForm';
    if (result && ownReturn) {
      if (result.dataset.welcomeResult === 'success') save({subscribed:true});
      open();
      return;
    }
    if (location.search.includes('customer_posted=true')) { save({subscribed:true}); return; }
    if (result?.dataset.welcomeResult === 'success') return;
    const eligible = () => { const state = read(); return !state.subscribed && !(state.until > Date.now()); };
    if (!eligible()) return;
    const tryOpen = () => {
      if (!dialog.isConnected || !eligible()) return;
      const active = document.activeElement;
      if (document.hidden || document.querySelector('dialog[open]') || active?.matches('input,textarea,select,[contenteditable="true"]') || document.querySelector('[aria-expanded="true"]')) {
        setTimeout(tryOpen,1000);
        return;
      }
      save({until:Date.now()+week});
      open();
    };
    setTimeout(tryOpen,8000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
